<script>
    export let context; context;
</script>
<div class="columns">
    
    <div class="column">
        <section class="section">
            <h1 class="title">
                Social Media
            </h1>
            <div class="content">
                <a href="https://twitter.com/TheSkillTreeCo" target="_blank">
                    <span class="icon-text">
                        <span class="icon">
                            <ion-icon name="logo-twitter"></ion-icon>
                        </span>
                        <span>Twitter</span>
                    </span>
                </a>
                <br>
                <a href="https://facebook.com/theskilltreecompany/" target="_blank">
                    <span class="icon-text">
                        <span class="icon">
                            <ion-icon name="logo-facebook"></ion-icon>
                        </span>
                        <span>Facebook</span>
                    </span>
                </a>
                <br>
                <a href="https://instagram.com/theskilltreeco/" target="_blank">
                    <span class="icon-text">
                        <span class="icon">
                            <ion-icon name="logo-instagram"></ion-icon>
                        </span>
                        <span>Instagram</span>
                    </span>
                </a>
            </div>
        </section>
    </div>
    <div class="column">
        <section class="section">
            <h1 class="title">
                Direct Contact
            </h1>
            <div class="content">
                Email: <a href="mailto:info@theskilltreecompany.com">info@theskilltreecompany.com</a>
                <br/>
                Telephone: <a href="tel:07765817408">07765817408</a>
            </div>
        </section>
    </div>
    <div class="column">
        <section class="section">
            <h1 class="title">
                Policies
            </h1>
            <div class="content">
                <a href="/privacy-policy">Privacy Poilcy</a>
                <br/>
                <a href="/terms-and-conditions">Website Terms and Conditions</a>
            </div>
        </section>
    </div>
</div>